import React from 'react';
import { DialogType } from '../../dialog/types';
import DialogsComponent from './dialogs';
import PageWithTitleLayout, {
    PageWithTitleType,
} from '../page-with-title/page-with-title-layout';

export type PageWithDialogType = PageWithTitleType & {
    dialogs: Record<
        string,
        Pick<
            DialogType,
            | 'label'
            | 'children'
            | 'icon'
            | 'fullScreen'
            | 'type'
            | 'maxWidth'
            | 'width'
            | 'strictClosing'
            | 'isSlider'
            | 'keepMounted'
        >
    >;
};

const PageWithDialogLayout: React.FC<PageWithDialogType> = ({
    title,
    slot,
    dialogs,
    children,
    titleClassName,
}) => {
    const dialogKeys: Array<string> = Object.keys(dialogs);

    return (
        <PageWithTitleLayout title={title} slot={slot} titleClassName={titleClassName}>
            {children}
            {dialogKeys.map((dialog) => (
                <DialogsComponent
                    key={dialog}
                    name={dialog}
                    {...dialogs[dialog]}
                />
            ))}
        </PageWithTitleLayout>
    );
};

export default PageWithDialogLayout;
